import React from "react";
import { Typography, Container, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import "./style.css";

const useStyles = makeStyles({
  downloadDetailSection: {
    backgroundImage:
      `url("/Buoyancy Images/Ban21-7-2.png")`,
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "50px 20px",
    textAlign: "center",
    position: "relative",
  },
  statistic: {
    fontSize: "2rem !important",
    fontWeight: "bold !important",
    color: "#fff",
    marginBottom: "10px",
  },
  description: {
    fontSize: "1rem !important",
    fontWeight: "bold !important",
    color: "#fff",
  },
});

interface Statistic {
  stat: number;
  description: string;
  suffix: string;
}

const statistics: Statistic[] = [
  { stat: 98, description: "Satisfaction", suffix: "%" },
  { stat: 360, description: "Reviews", suffix: "+" },
  { stat: 45000, description: "Downloads", suffix: "+" },
];

const DownloadDetailSection: React.FC = () => {
  const classes = useStyles();
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <div className={classes.downloadDetailSection} ref={ref}>
      <img
        src="/Buoyancy Images/circle.png"
        className="circle"
        alt="animation round"
      />
      <img
        src="/Buoyancy Images/triangle.png"
        className="triangle"
        alt="animation triangle"
      />
      <Container>
        <Typography variant="body1" paragraph className="text-white">
          SwapToon is more than just a face swap app—it's a creative playground
          that lets you have fun with your photos in countless ways.
        </Typography>
        <Grid container justifyContent="center" spacing={4}>
          {statistics.map((stat, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Typography className={classes.statistic}>
                {inView ? (
                  <CountUp
                    start={0}
                    end={stat.stat}
                    duration={2.5}
                    separator=","
                    suffix={stat.suffix}
                  />
                ) : (
                  "0"
                )}
              </Typography>
              <Typography className={classes.description}>
                {stat.description}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
};

export default DownloadDetailSection;
